import {
  SamplingCheckIcon,
  SamplingStepPendingIcon
} from '@/components/common/icon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ModalAddress.module.less';

const AddressProgress: React.FC<{
  step: 1 | 2 | 3;
  hasProductSelection: boolean;
}> = ({ step, hasProductSelection }) => {
  const { t } = useTranslation();
  const steps = [
    t('modal.address.agreement.step_title', { defaultValue: 'Agree to terms' }),
    ...(hasProductSelection
      ? [
          t('modal.address.select_product_title', {
            defaultValue: 'Select your product'
          })
        ]
      : []),
    t('modal.address.agreement.address_step_title', {
      defaultValue: 'Submit address'
    })
  ];
  return (
    <div className="relative mb-4 flex w-full items-start gap-4 rounded-lg bg-[#FAFAFA] py-3">
      <div
        className="absolute top-6 h-0.5 bg-[#E5E5E5]"
        style={{
          left: steps.length === 3 ? '120px' : '25%',
          right: steps.length === 3 ? '120px' : '25%'
        }}
      />
      <div
        className="absolute top-6 h-0.5 bg-[#FF621D]"
        style={{
          left: steps.length === 3 ? '120px' : '25%',
          width:
            steps.length === 3
              ? `calc((100% - 240px) * ${Math.max(1, step - 1) / 2})`
              : `${Math.max(0, step - 1) * 50}%`
        }}
      />
      {steps.map((label, index) => {
        const number = index + 1;
        const completed = step > number;
        const active = step === number;
        return (
          <div
            key={label}
            className="relative z-[1] flex flex-1 flex-col items-center gap-3"
          >
            <div
              key={`${number}-${completed}-${active}`}
              className="relative flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#FAFAFA]"
            >
              {completed ? (
                <div className="flex h-6 w-6 items-center justify-center rounded-full bg-[#FF621D]">
                  <SamplingCheckIcon />
                </div>
              ) : active ? (
                <span
                  aria-hidden="true"
                  className={`${styles.currentStepIcon} flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#FF621D]`}
                >
                  <span className="h-2 w-2 rounded-full bg-white" />
                </span>
              ) : (
                <SamplingStepPendingIcon />
              )}
            </div>
            <div
              className={`text-center text-sm font-semibold leading-5 ${active ? 'text-[#DF541B]' : 'text-[#404040]'}`}
            >
              {label}
            </div>
          </div>
        );
      })}
    </div>
  );
};
export default AddressProgress;
